import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const setContactFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};

const clearContactFormData = (state) =>{
  return {
    ...state,
    data:{}
  }
}

const initialState = {};

export default createReducer(initialState, {
  [TYPES.SET_CONTACT_FORM_DATA]: setContactFormData,
  [TYPES.CLEAR_CONTACT_FORM_DATA]: clearContactFormData
});
